// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paragraph {
  line-height: 1.4;
}
.paragraph--1 {
  font-size: 14px;
}
@media all and (min-width: 1280px) {
  .paragraph--1 {
    font-size: 16px;
  }
}
.paragraph--2 {
  font-size: 12px;
}
@media all and (min-width: 1280px) {
  .paragraph--2 {
    font-size: 14px;
  }
}
.paragraph--3 {
  font-size: 10px;
}
@media all and (min-width: 1280px) {
  .paragraph--3 {
    font-size: 12px;
  }
}
.paragraph--underlined {
  text-decoration: underline;
  color: rgba(21, 21, 21, 0.7490196078);
  transition-duration: 250ms;
}
.paragraph--underlined:hover {
  color: rgba(21, 21, 21, 0.5019607843);
}`, "",{"version":3,"sources":["webpack://./src/components/Paragraph/Paragraph.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAGE;EACE,eAAA;AADJ;AAGI;EAHF;IAII,eAAA;EAAJ;AACF;AAGE;EACE,eAAA;AADJ;AAGI;EAHF;IAII,eAAA;EAAJ;AACF;AAGE;EACE,eAAA;AADJ;AAGI;EAHF;IAII,eAAA;EAAJ;AACF;AAGE;EACE,0BAAA;EACA,qCCHO;EDIP,0BAAA;AADJ;AAGI;EACE,qCCNK;ADKX","sourcesContent":["@import 'src/styles/variables';\n\n.paragraph {\n  line-height: 1.4;\n\n  &--1 {\n    font-size: 14px;\n\n    @media all and (min-width: $desktop) {\n      font-size: 16px;\n    }\n  }\n\n  &--2 {\n    font-size: 12px;\n\n    @media all and (min-width: $desktop) {\n      font-size: 14px;\n    }\n  }\n\n  &--3 {\n    font-size: 10px;\n\n    @media all and (min-width: $desktop) {\n      font-size: 12px;\n    }\n  }\n\n  &--underlined {\n    text-decoration: underline;\n    color: $black-75;\n    transition-duration: 250ms;\n\n    &:hover {\n      color: $black-50;\n    }\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
